// extracted by mini-css-extract-plugin
export default {"landing-page":"styles_landing-page__zhjAO","left-section":"styles_left-section__4Yppg","right-section":"styles_right-section__BjNC6"};